import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '../lib/cn.js';
export const badgeVariants = cva('inline-flex w-fit items-center gap-2 rounded-full px-3 py-1 font-body text-sm font-medium', {
    variants: {
        variant: {
            neutral: 'bg-muted text-muted-foreground',
            accent: 'bg-secondary text-secondary-foreground',
            destructive: 'bg-destructive text-destructive-foreground',
            outline: 'border border-input bg-card text-card-foreground',
        },
    },
    defaultVariants: { variant: 'neutral' },
});
const shapeClasses = {
    circle: 'rounded-full',
    diamond: 'rotate-45 rounded-sm',
    square: 'rounded-sm',
};
export const Badge = ({ className, variant, icon, shape, children, ...rest }) => (_jsxs("span", { className: cn(badgeVariants({ variant }), className), ...rest, children: [shape === undefined ? null : (_jsx("span", { "aria-hidden": "true", "data-badge-shape": shape, className: cn('h-2 w-2 shrink-0 bg-current', shapeClasses[shape]) })), icon === undefined ? null : (_jsx("span", { "aria-hidden": "true", className: "inline-flex shrink-0 items-center", children: icon })), _jsx("span", { children: children })] }));
//# sourceMappingURL=badge.js.map